<template>
    <v-sheet>
        <v-container fluid>
            <v-row>
                <v-col cols="5">
                    <v-row>
                        <v-col>
                            <div class="section-heading font-weight-bold">
                                Job / Part
                            </div>

                            <v-row :dense="true">
                                <v-col
                                    cols="5"
                                    class="d-flex align-center justify-end"
                                >
                                    <v-btn
                                        class="w-100"
                                        color="close"
                                        @click="
                                            $refs.jobSearchModalRef.showModal()
                                        "
                                        >Job&nbsp;<span class="text-red"
                                            >*</span
                                        ></v-btn
                                    >
                                </v-col>
                                <v-col cols="7">
                                    <v-text-field
                                        v-model="this.form.JobNum"
                                        label="Job"
                                        variant="outlined"
                                        density="compact"
                                        color="primary"
                                        hide-details
                                        @focusout="jobNumberChange"
                                        @keydown.enter="jobNumberChange"
                                        @keydown.tab="jobNumberChange"
                                        @input="updateJobNumber"
                                    ></v-text-field>
                                </v-col>
                                <span class="error-message">{{
                                    errors.jobNum
                                }}</span>
                            </v-row>

                            <v-row :dense="true">
                                <v-col
                                    cols="5"
                                    class="d-flex align-center justify-end"
                                >
                                    <v-btn
                                        class="w-100"
                                        color="close"
                                        :disabled="
                                            parseInt(job?.JobClosed) !== 0
                                        "
                                        @click="partModal"
                                        >Part&nbsp;<span class="text-red"
                                            >*</span
                                        ></v-btn
                                    >
                                </v-col>
                                <v-col cols="7">
                                    <v-text-field
                                        v-model="form.PartNum"
                                        label="Part"
                                        variant="outlined"
                                        density="compact"
                                        color="primary"
                                        hide-details
                                        :readonly="
                                            parseInt(job?.JobClosed) !== 0
                                        "
                                        @focusout="createNewJobCall"
                                        @keydown.enter="createNewJobCall"
                                        @keydown.tab="createNewJobCall"
                                        @input="updatePartNumber"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row :dense="true">
                                <v-col cols="5">
                                    <v-btn
                                        class="w-100"
                                        color="close"
                                        :disabled="true"
                                        >Desc</v-btn
                                    >
                                </v-col>
                                <v-col cols="7">
                                    <v-textarea
                                        v-model="form.PartDescription"
                                        label="Desc"
                                        variant="outlined"
                                        density="compact"
                                        rows="4"
                                        color="primary"
                                        hide-details
                                        :readonly="job?.JobClosed !== '0'"
                                        @focusout="handlePartDescriptionChange"
                                        @keydown.enter="
                                            handlePartDescriptionChange
                                        "
                                        @keydown.tab="
                                            handlePartDescriptionChange
                                        "
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row :dense="true">
                        <v-col cols="5">
                            <v-btn class="w-100" color="close" :disabled="true"
                                >Desc</v-btn
                            >
                        </v-col>
                        <v-col cols="7">
                            <v-textarea
                                v-model="form.PartDescription"
                                label="Desc"
                                variant="outlined"
                                density="compact"
                                rows="4"
                                color="primary"
                                hide-details
                                :readonly="parseInt(job?.JobClosed) !== 0"
                                @focusout="handlePartDescriptionChange"
                                @keydown.enter="handlePartDescriptionChange"
                                @keydown.tab="handlePartDescriptionChange"
                            ></v-textarea>
                        </v-col>
                    </v-row>

                    <v-row :dense="true">
                        <v-col cols="4">
                            <v-btn
                                class="w-100"
                                :color="
                                    job.JobType == 'RWK' ? 'warning' : 'close'
                                "
                                :disabled="
                                    !job || parseInt(job?.JobClosed) !== 0
                                "
                                @click="openReworkModal"
                                >REWORK</v-btn
                            >
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-if="job.JobType == 'RWK'"
                                v-model="form.ReworkJobNum"
                                label="Rework Of:"
                                variant="outlined"
                                density="compact"
                                color="primary"
                                hide-details
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-checkbox
                                @click="handleMaintenanceJobChange"
                                class="w-100"
                                v-model="form.MaintenanceJob"
                            >Maintenance Job</v-checkbox
                            >
                        </v-col>
                    </v-row>

                    <v-divider class="my-3"></v-divider>

                    <div class="section-heading font-weight-bold">Project</div>

                    <v-row :dense="true">
                        <v-col cols="5" class="d-flex align-center justify-end">
                            <v-btn
                                class="w-100"
                                color="close"
                                :disabled="parseInt(job?.JobClosed) !== 0"
                                @click="projectModal"
                                >Project ID&nbsp;<span class="text-red"
                                    >*</span
                                ></v-btn
                            >
                        </v-col>
                        <v-col cols="7">
                            <v-text-field
                                v-model="form.ProjectID"
                                label="Job"
                                variant="outlined"
                                density="compact"
                                color="primary"
                                hide-details
                                :readonly="parseInt(job?.JobClosed) !== 0"
                                @focusout="handleProjectIdChange"
                                @keydown.enter="handleProjectIdChange"
                                @keydown.tab="handleProjectIdChange"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-divider class="my-3"></v-divider>

                    <v-row>
                        <v-col>
                            <v-row :dense="true">
                                <v-col
                                    cols="5"
                                    class="d-flex align-center justify-end"
                                    >Group:&nbsp;<span class="text-red"
                                        >*</span
                                    ></v-col
                                >
                                <v-col cols="7">
                                    <v-text-field
                                        v-model="form.ProdGroupDesc"
                                        label="Group"
                                        variant="outlined"
                                        density="compact"
                                        color="primary"
                                        hide-details
                                        :readonly="true"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row :dense="true">
                                <v-col
                                    cols="5"
                                    class="d-flex align-center justify-end"
                                    >Project Manager:&nbsp;<span
                                        class="text-red"
                                        >*</span
                                    ></v-col
                                >
                                <v-col cols="7">
                                    <v-select
                                        v-model="form.person_id"
                                        :items="personsArray"
                                        item-title="username"
                                        item-value="id"
                                        label="Project Manager"
                                        variant="outlined"
                                        density="compact"
                                        color="primary"
                                        hide-details
                                        :readonly="
                                            parseInt(job?.JobClosed) !== 0
                                        "
                                        @update:modelValue="
                                            handlePersonIdChange
                                        "
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>

                <v-col>
                    <v-row>
                        <v-col cols="8">
                            <v-container fluid>
                                <v-row>
                                    <v-col>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-row
                                                    class="bg-red-lighten-3 pa-1"
                                                >
                                                    <v-col>
                                                        <div
                                                            class="section-heading font-weight-bold"
                                                        >
                                                            Quantities
                                                        </div>

                                                        <v-row
                                                            style="margin: auto"
                                                            :dense="true"
                                                        >
                                                            <v-col cols="12">
                                                                <v-select
                                                                    v-model="
                                                                        form.WarehouseCode
                                                                    "
                                                                    item-value="name"
                                                                    item-title="description"
                                                                    label="Warehouse"
                                                                    :items="
                                                                        buildingArray
                                                                    "
                                                                    variant="outlined"
                                                                    density="compact"
                                                                    @update:modelValue="
                                                                        handleQtyWarehouseChange
                                                                    "
                                                                ></v-select>
                                                            </v-col>
                                                        </v-row>

                                                        <v-row :dense="true">
                                                            <v-col
                                                                cols="3"
                                                                class="d-flex align-center justify-end"
                                                                >Prod:</v-col
                                                            >
                                                            <v-col cols="9">
                                                                <v-text-field
                                                                    v-model="
                                                                        form.ProdQty
                                                                    "
                                                                    variant="outlined"
                                                                    density="compact"
                                                                    hide-details
                                                                    type="number"
                                                                    placeholder="0"
                                                                    color="primary"
                                                                    :readonly="
                                                                        parseInt(
                                                                            job?.JobClosed
                                                                        ) !== 0
                                                                    "
                                                                    @focusout="
                                                                        handleProdQtyChange
                                                                    "
                                                                    @keydown.enter="
                                                                        handleProdQtyChange
                                                                    "
                                                                    @keydown.tab="
                                                                        handleProdQtyChange
                                                                    "
                                                                ></v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>

                                        <v-divider :vertical="true"></v-divider>

                                        <v-row>
                                            <v-col>
                                                <div
                                                    class="section-heading font-weight-bold"
                                                >
                                                    Dates
                                                </div>

                                                <v-row :dense="true">
                                                    <v-col
                                                        cols="5"
                                                        class="d-flex align-center justify-end"
                                                        >Ship By:&nbsp;<span
                                                            class="text-red"
                                                            >*</span
                                                        ></v-col
                                                    >
                                                    <v-col cols="7">
                                                        <v-text-field
                                                            v-model="
                                                                form.ReqDueDate
                                                            "
                                                            label="Ship By"
                                                            variant="outlined"
                                                            density="compact"
                                                            type="date"
                                                            color="primary"
                                                            hide-details
                                                            :readonly="
                                                                parseInt(
                                                                    job?.JobClosed
                                                                ) !== 0
                                                            "
                                                            @focusout="
                                                                handleReqDueDateChange
                                                            "
                                                            @keydown.enter="
                                                                handleReqDueDateChange
                                                            "
                                                            @keydown.tab="
                                                                handleReqDueDateChange
                                                            "
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-row :dense="true">
                                                    <v-col
                                                        cols="5"
                                                        class="d-flex align-center justify-end"
                                                        >Initial
                                                        Entry:&nbsp;<span
                                                            class="text-red"
                                                            >*</span
                                                        ></v-col
                                                    >
                                                    <v-col cols="7">
                                                        <v-text-field
                                                            v-model="
                                                                form.CreateDate
                                                            "
                                                            label="Initial Entry"
                                                            variant="outlined"
                                                            density="compact"
                                                            type="date"
                                                            color="primary"
                                                            hide-details
                                                            :readonly="true"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-row :dense="true">
                                                    <v-col
                                                        cols="5"
                                                        class="d-flex align-center justify-end"
                                                        >Start:</v-col
                                                    >
                                                    <v-col cols="7">
                                                        <v-text-field
                                                            v-model="
                                                                form.StartDate
                                                            "
                                                            label="Start"
                                                            variant="outlined"
                                                            density="compact"
                                                            type="date"
                                                            color="primary"
                                                            hide-details
                                                            :readonly="true"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>

                        <v-col cols="4">
                            <div class="section-heading font-weight-bold">
                                Status
                            </div>

                            <v-row :dense="true">
                                <v-col cols="8" class="d-flex align-center">
                                    <v-btn
                                        class="w-100 button-font"
                                        :color="closedBtnColor"
                                        >{{
                                            parseInt(job?.JobClosed) === 0
                                                ? "Open"
                                                : "Closed"
                                        }}</v-btn
                                    >
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col>&nbsp;</v-col>
                            </v-row>

                            <v-row
                                :dense="true"
                                @click="hanldeIsEngineeredClick"
                            >
                                <v-col cols="8" class="d-flex align-center">
                                    <v-btn
                                        class="w-100 button-font"
                                        :color="engineeredBtnColorComputed"
                                        >Engineered</v-btn
                                    >
                                </v-col>
                                <v-col cols="4" class="d-flex align-center">
                                    <v-checkbox
                                        v-model="form.JobEngineered"
                                        color="primary"
                                        density="compact"
                                        hide-details
                                        value="1"
                                        :readonly="true"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>

                            <v-row :dense="true" @click="hanldeIsReleasedClick">
                                <v-col
                                    cols="8"
                                    class="d-flex align-center flex-column"
                                >
                                    <v-btn
                                        class="w-100 button-font"
                                        :color="releasedBtnColorComputed"
                                        >Released</v-btn
                                    >
                                    <v-btn
                                        class="w-100 button-font"
                                        :color="releasedBtnColorComputed"
                                        >Scheduled</v-btn
                                    >
                                </v-col>
                                <v-col cols="4" class="d-flex align-center">
                                    <v-checkbox
                                        v-model="form.JobReleased"
                                        color="primary"
                                        density="compact"
                                        hide-details
                                        value="1"
                                        :readonly="true"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
        <v-row>
            <v-col cols="12">
                <v-textarea
                    v-model="form.CommentText"
                    label="Job Comments"
                    variant="outlined"
                    :readonly="parseInt(job?.JobClosed) !== 0"
                    @focusout="handleCommentChange"
                    @keydown.tab="handleCommentChange"
                ></v-textarea>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogs.openPartSearchDialog">
            <PartSearch @partNumberReceived="partNumberReceived" />
        </v-dialog>

        <v-dialog v-model="dialogs.openProjectIdDialog">
            <ProjectSearch @projectIdReceived="projectIdReceived" />
        </v-dialog>

        <v-dialog v-model="dialogs.releasedDialog" max-width="800">
            <JobReleasedModal
                @emails-sent="emailsSent"
                @close-modal="closeReleasedModal"
            />
        </v-dialog>

        <JobSearchModal
            @job-selected="(selectedJob) => (job = selectedJob)"
            ref="jobSearchModalRef"
        />
        <v-dialog v-model="dialogs.reworkDialog" max-width="700">
            <v-card>
                <v-card-title class="headline">
                    <div
                        style="
                            text-align: center;
                            white-space: inherit;
                            padding: 10px;
                            overflow-x: hidden;
                        "
                    >
                        Enter The Original Job Number to be linked to this
                        Rework Job<br />
                    </div>
                </v-card-title>
                <v-container fluid>
                    <v-row class="mt-4">
                        <v-col cols="12">
                            <v-text-field
                                label="Original Job Number"
                                variant="underlined"
                                v-model="form.ReworkJobNum"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-btn
                                color="close"
                                variant="text"
                                block
                                @click="closeReworkModal()"
                                >Close
                            </v-btn>
                        </v-col>
                        <v-col cols="6">
                            <v-btn
                                color="blue"
                                variant="text"
                                block
                                @click="handleReworkChange()"
                                >Submit
                            </v-btn>
                        </v-col>
                        <v-col
                            cols="12"
                            class="mb-4"
                            v-if="job.JobType == 'RWK'"
                        >
                            <v-btn
                                color="red"
                                variant="text"
                                block
                                @click="handleReworkChange('clear')"
                                >Cancel Rework Link
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </v-sheet>
</template>

<script>
import { defineAsyncComponent } from "vue";
import moment from "moment";
import axios from "axios";

// WINDOWS
const DemandSummaryTable = defineAsyncComponent(() =>
    import("./JobWindow/DemandSummaryTable.vue")
);
const MakeToStockWindow = defineAsyncComponent(() =>
    import("./JobWindow/MakeToStockWindow.vue")
);

// MODALS / DIALOGS
const JobSearchModal = defineAsyncComponent(() =>
    import("./../Modals/JobSearchModal.vue")
);
const PartSearch = defineAsyncComponent(() =>
    import("./../../Part/PartSearch.vue")
);
const ProjectSearch = defineAsyncComponent(() =>
    import("./../Modals/ProjectSearch.vue")
);
const JobReleasedModal = defineAsyncComponent(() =>
    import("./../Modals/JobReleased.vue")
);

import { mapWritableState } from "pinia";
import { useJobEntryStore } from "../../../../stores/ProjectManagement/JobEntry";

export default {
    name: "JobWindow",
    components: {
        DemandSummaryTable,
        MakeToStockWindow,
        JobSearchModal,
        PartSearch,
        ProjectSearch,
        JobReleasedModal,
    },
    data() {
        return {
            tab: "Demand Summary",
            createNewBool: false,
            savedPartNum: null,
            dialogs: {
                openPartSearchDialog: false,
                openProjectIdDialog: false,
                releasedDialog: false,
                reworkDialog: false,
            },
            runningProcesses: {
                createNewJobRunning: false,
                jobNumberChange: false,
                updatingProjectId: false,
                updatingProductionQuantity: false,
                updatingComment: false,
            },
            form: {
                JobNum: null,
                PartNum: null,
                PartDescription: null,
                ProjectID: null,
                ProdQty: null,
                ReqDueDate: null,
                StartDate: null,
                CreateDate: null,
                JobEngineered: null,
                JobReleased: null,
                JobClosed: null,
                person_id: null,
                WarehouseCode: null,
                ReworkJobNum: null,
                JobLinked: null,
                MaintenanceJob:false,
            },
            errors: {
                jobNum: null,
            },
            personsArray: [],
            buildingArray: [],
        };
    },
    watch: {
        job(value, oldValue) {
            this.form.JobNum = value.JobNum;
            this.form.PartNum = value.PartNum;
            this.form.PartDescription = value.PartDescription;
            this.form.ProjectID = value.ProjectID;
            this.form.ProdQty = value.ProdQty
                ? parseFloat(value.ProdQty.replace(",", ""))
                : null;

            let dateObject;
            let month;
            let day;
            let year;
            if (value.ReqDueDate) {
                dateObject = moment(value.ReqDueDate);
                this.form.ReqDueDate = dateObject.format("YYYY-MM-DD");
            } else {
                this.form.ReqDueDate = null;
            }

            if (value.StartDate) {
                dateObject = moment(value.StartDate);
                this.form.StartDate = dateObject.format("YYYY-MM-DD");
            } else {
                this.form.StartDate = null;
            }

            if (value.CreateDate) {
                dateObject = moment(value.CreateDate);
                this.form.CreateDate = dateObject.format("YYYY-MM-DD");
            } else {
                this.form.CreateDate = null;
            }

            this.form.JobEngineered = String(value.JobEngineered);
            this.form.JobReleased = String(value.JobReleased);
            this.form.JobClosed = value.JobClosed;
            this.form.CommentText = value.CommentText;
            this.form.person_id = value?.person_id ?? null;
            this.form.WarehouseCode = value.WarehouseCode;
            this.form.ProdGroupDesc =
                value.Project.Project_UD?.ProdGroup.Description ??
                value.Project.Description;
            this.form.ReworkJobNum = value.ReworkJobNum;
            this.form.MaintenanceJob = value.MaintenanceJob;
        },
        newJobNumUpdated(value, oldValue) {
            if (value) {
                this.clearJob();
                this.job.JobNum = value;
                this.createNewJobStart();
                this.setTemporaryMessage("Creating new Job");
                this.newJobNumUpdated = null;
            }
        },
    },
    computed: {
        ...mapWritableState(useJobEntryStore, {
            job: "job", // localVariableName: "variableWithinStore"
            setJob: "setJob",
            clearJob: "clearJob",
            overlay: "overlay",
            fetchJobData: "fetchJobData",
            setErrorMessage: "setErrorMessage",
            setTemporaryMessage: "setTemporaryMessage",
            setCurrentAssemblyMaterials: "setCurrentAssemblyMaterials",
            newJobNumUpdated: "newJobNumUpdated",
        }),
        engineeredBtnColorComputed() {
            if (!this.job.JobNum) {
                return "transparent";
            }
            if (parseInt(this.form.JobEngineered)) {
                return "green";
            } else {
                return "red";
            }
        },
        releasedBtnColorComputed() {
            if (!this.job.JobNum) {
                return "transparent";
            }
            if (parseInt(this.form.JobReleased)) {
                return "green";
            } else {
                return "red";
            }
        },
        closedBtnColor() {
            switch (parseInt(this.job.JobClosed)) {
                case 0:
                    return "green";
                case 1:
                    return "red";
                default:
                    return "close";
            }
        },
    },
    mounted() {
        this.fetchBuilding();
        this.fetchPersons();
    },
    unmounted() {
        this.clearJob();
    },
    methods: {
        emailsSent() {
            //
        },
        closeReleasedModal() {
            this.dialogs.releasedDialog = false;
        },
        updateJobNumber(event) {
            // Get the current cursor position
            const cursorPosition = event.target.selectionStart;
            const inputElement = event.target;

            // Update the value to uppercase
            this.form.JobNum = this.truncateJobNum(
                this.form.JobNum
            ).toUpperCase();

            // Restore the cursor position
            this.$nextTick(() => {
                inputElement.setSelectionRange(cursorPosition, cursorPosition);
            });
        },
        truncateJobNum(str) {
            if (str.length > 15) {
                this.errors.jobNum =
                    "Job Number can only be 15 characters long";
                return str.slice(0, 15);
            } else {
                return str;
            }
        },
        updatePartNumber(event) {
            // Get the current cursor position
            const cursorPosition = event.target.selectionStart;
            const inputElement = event.target;

            // Update the value to uppercase
            this.form.PartNum = this.form.PartNum.toUpperCase();

            // Restore the cursor position
            this.$nextTick(() => {
                inputElement.setSelectionRange(cursorPosition, cursorPosition);
            });
        },
        fetchBuilding() {
            try {
                //NO NEED FOR EXT OR VENDORS. ONLY GET NUMBER BUILDINGS
                axios
                    .get(
                        route("api.buildings.index", {
                            countryCodeFK: "US",
                            state: "NY",
                        })
                    )
                    .then((res) => {
                        this.buildingArray = res.data;
                        this.buildingArray.push({
                            name: "EXT",
                            description: "External Warehouses",
                        });
                        this.buildingArray.push({
                            name: "VENDORS",
                            description: "Suppliers Managed Inventory",
                        });
                    });
            } catch (err) {
                console.log(err);
            }
        },
        partModal() {
            this.dialogs.openPartSearchDialog = true;
        },
        projectModal() {
            this.dialogs.openProjectIdDialog = true;
        },
        partNumberReceived(partNum) {
            this.dialogs.openPartSearchDialog = false;
            this.form.PartNum = partNum;
            this.job.PartNum = partNum;

            this.createNewJobCall();
        },
        projectIdReceived(projectID) {
            this.dialogs.openProjectIdDialog = false;
            this.form.ProjectID = projectID;

            this.handleProjectIdChange();
        },
        fetchPersons() {
            axios
                .get(route("api.epicor.jobs.persons"))
                .then(async (response) => {
                    this.personsArray = response.data;
                })
                .catch((response) => {
                    console.log("Err: " + response);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        createNewJobCall() {
            if (
                this.createNewBool &&
                !this.runningProcesses.createNewJobRunning &&
                this.form.PartNum &&
                this.savedPartNum !== this.form.PartNum
            ) {
                this.savedPartNum = this.form.PartNum;
                this.runningProcesses.createNewJobRunning = true;
                this.overlay = true;
                let params = {
                    jobNum: this.form.JobNum,
                    partNum: this.form.PartNum,
                };

                axios
                    .post(route("api.epicor.jobs.create"), params)
                    .then((response) => {
                        if (response.data.Status === 0) {
                            this.setErrorMessage(response.data.Message);
                        } else {
                            this.setJob(response.data.data);
                        }
                    })
                    .catch((response) => {
                        console.log("Err: " + response);
                    })
                    .finally(() => {
                        this.runningProcesses.createNewJobRunning = false;
                        this.overlay = false;
                    });
            }
        },
        jobNumberChange() {
            if (
                !this.runningProcesses.jobNumberChange &&
                (this.form.JobNum !== this.job.JobNum || !this.job.JobNum)
            ) {
                this.runningProcesses.jobNumberChange = true;
                if (!this.form.JobNum) {
                    this.runningProcesses.jobNumberChange = false;
                    this.createNewJobStart();
                    this.clearJob();

                    return;
                }

                const pattern = /^\d{2}-\d{3}\/.+/;
                if (!pattern.test(this.form.JobNum)) {
                    let jobNumStored = this.form.JobNum;
                    this.runningProcesses.jobNumberChange = false;
                    this.setErrorMessage(
                        "Job Number is not in the correct format. \n example format: 15-040/JOB1"
                    );
                    this.createNewJobStart();
                    this.clearJob();
                    setTimeout(() => {
                        this.form.JobNum = jobNumStored;
                    }, 10);

                    return;
                }

                this.overlay = true;
                let params = {
                    fields: ["JobNum", "SysRowID"],
                    jobNum: this.form.JobNum,
                };

                axios
                    .get(route("api.epicor.jobs.search"), { params: params })
                    .then(async (response) => {
                        let JobNum = null;
                        response.data.data.forEach((jobObj) => {
                            if (jobObj.JobNum === this.form.JobNum) {
                                JobNum = jobObj.JobNum;
                            }
                        });

                        if (JobNum) {
                            let job = await this.fetchJobData(JobNum);
                            this.setJob(job);

                            this.runningProcesses.jobNumberChange = false;
                            this.overlay = false;
                        } else {
                            this.runningProcesses.jobNumberChange = false;
                            let savedJobNum = this.form.JobNum;
                            this.clearJob();

                            this.setTemporaryMessage(
                                "This Job Number doesnt exits yet, creating new Job"
                            );
                            this.overlay = false;
                            this.createNewJobStart();
                            setTimeout(() => {
                                this.form.JobNum = savedJobNum;
                            }, 50);
                        }
                    })
                    .catch((response) => {
                        // HANDLE ERRORS
                        this.loadingTableData = false;
                        this.overlay = false;
                    });
            }
        },
        async handlePartDescriptionChange() {
            if (
                !this.runningProcesses.updatingPartDescription &&
                this.job.PartDescription !== this.form.PartDescription
            ) {
                this.runningProcesses.updatingPartDescription = true;
                let params = {
                    PartDescription: this.form.PartDescription,
                    type: "PartDescription",
                };

                await this.sendUpdateCall(params);

                this.runningProcesses.updatingPartDescription = false;
            }
        },
        async handleMaintenanceJobChange() {

            let params = {
                MaintenanceJob: !this.form.MaintenanceJob,
                type: "MaintenanceJob",
            };

            await this.sendUpdateCall(params);
        },
        async handleProjectIdChange() {
            if (
                !this.runningProcesses.updatingProjectId &&
                this.job.ProjectID !== this.form.ProjectID
            ) {
                this.runningProcesses.updatingProjectId = true;
                let params = {
                    ProjectId: this.form.ProjectID,
                    type: "ProjectId",
                };

                await this.sendUpdateCall(params);

                this.runningProcesses.updatingProjectId = false;
            }
        },
        async handleProdQtyChange() {
            if (this.job.IssuedQtyBool) {
                this.setErrorMessage(
                    "You can not update the quantity of a Job that has had quantity issued to a material"
                );
                this.form.ProdQty = this.job.ProdQty;

                return;
            }

            if (
                !this.runningProcesses.updatingProductionQuantity &&
                this.form.ProdQty !== this.job.ProdQty
            ) {
                this.runningProcesses.updatingProductionQuantity = true;
                let params = {
                    ProdQty: this.form.ProdQty,
                    WarehouseCode: this.form.WarehouseCode,
                    type: "ProdQty",
                };

                await this.sendUpdateCall(params);
                this.runningProcesses.updatingProductionQuantity = false;
            }
        },
        async handleQtyWarehouseChange() {
            if (
                this.form.ProdQty &&
                this.job.WarehouseCode &&
                this.form.WarehouseCode !== this.job.WarehouseCode
            ) {
                this.runningProcesses.updatingProductionQuantity = true;
                let params = {
                    ProdQty: this.form.ProdQty,
                    WarehouseCode: this.form.WarehouseCode,
                    OldWarehouseCode: this.job.WarehouseCode,
                    type: "QtyWarehouse",
                };

                await this.sendUpdateCall(params);
                this.runningProcesses.updatingProductionQuantity = false;
            }
        },
        async handleCommentChange() {
            if (
                !this.runningProcesses.updatingComment &&
                this.form.CommentText !== this.job.CommentText
            ) {
                this.runningProcesses.updatingComment = true;
                let params = {
                    CommentText: this.form.CommentText,
                    type: "CommentText",
                };

                await this.sendUpdateCall(params);
                this.runningProcesses.updatingComment = false;
            }
        },
        handleReqDueDateChange() {
            if (this.job.ReqDueDate) {
                let dateObject = new Date(this.job.ReqDueDate);
                let month = (dateObject.getMonth() + 1)
                    .toString()
                    .padStart(2, "0"); // getMonth() is zero-based
                let day = dateObject.getDate().toString().padStart(2, "0");
                let year = dateObject.getFullYear();
                this.job.ReqDueDate = `${year}-${month}-${day}`;
            }

            if (this.form.ReqDueDate !== this.job.ReqDueDate) {
                let params = {
                    ReqDueDate: this.form.ReqDueDate,
                    type: "ReqDueDate",
                };

                this.sendUpdateCall(params);
            }
        },
        hanldeIsEngineeredClick() {
            let params = {
                JobEngineered: this.form.JobEngineered === "1" ? "0" : "1",
                type: "JobEngineered",
            };

            this.sendUpdateCall(params);

            if (
                this.job.PartNum &&
                this.job.JobNum &&
                parseInto(this.job.JobClosed) === 0
            ) {
                this.job.JobEngineered =
                    this.job.JobEngineered === "1" ? "0" : "1";
                this.form.JobEngineered =
                    this.form.JobEngineered === "1" ? "0" : "1";
            }
        },
        async hanldeIsReleasedClick() {
            let params = {
                JobReleased: this.form.JobReleased === "1" ? "0" : "1",
                type: "JobReleased",
            };

            this.sendUpdateCall(params);

            if (
                this.job.PartNum &&
                this.job.JobNum &&
                parseInt(this.job.JobClosed) === 0
            ) {
                this.job.JobReleased = this.job.JobReleased === "1" ? "0" : "1";
                this.form.JobReleased =
                    this.form.JobReleased === "1" ? "0" : "1";
            }
        },
        async handlePersonIdChange() {
            let params = {
                person_id: this.form.person_id,
                type: "person_id",
            };

            await this.sendUpdateCall(params);
        },
        async handleReworkChange(mode) {
            let reworkjobnum = mode === "clear" ? null : this.form.ReworkJobNum;
            let params = {
                ReworkJobNum: reworkjobnum,
                type: "Rework",
            };
            await this.sendUpdateCall(params);
            this.closeReworkModal();
        },
        async sendUpdateCall(additionalParams) {
            if (
                this.job.PartNum &&
                this.job.JobNum &&
                parseInt(this.job.JobClosed) === 0
            ) {
                this.overlay = true;
                let params = {
                    JobNum: this.job.JobNum,
                    PartNum: this.job.PartNum,
                    JobId: this.job.job_id,
                };
                params = { ...params, ...additionalParams };

                await axios
                    .post(route("api.epicor.jobs.update"), params)
                    .then(async (response) => {
                        if (response.data.Status === 0) {
                            if (response.data.Type === 0) {
                                this.overlay = false;
                                if (params.type === "JobReleased") {
                                    this.form.JobReleased =
                                        !this.form.JobReleased;
                                    this.job.JobReleased =
                                        this.form.JobReleased;
                                }
                                if (params.type === "ReqDueDate") {
                                    this.form.ReqDueDate = this.job.ReqDueDate;
                                }
                                alert(response.data.Message);
                                let job = await this.fetchJobData(
                                    this.job.JobNum
                                );
                                this.setJob(job);
                            } else {
                                if (params.type === "Rework") {
                                    this.form.ReworkJobNum = this.job.ReworkJobNum;
                                }
                                this.setErrorMessage(response.data.Message);
                            }
                        } else if (response.data.Status === 1) {
                            let job = await this.fetchJobData(this.job.JobNum);
                            this.setJob(job);

                            if (this.job.JobReleased) {
                                this.dialogs.releasedDialog = true;
                            }
                        }
                    })
                    .catch((response) => {
                        console.log("Err: " + response);
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            }
        },
        async refreshBom() {
            let JobNum = this.job.JobNum;
            let job = await this.fetchJobData(JobNum);
            this.setJob(job);
        },
        createNewJobStart() {
            this.createNewBool = true;
            this.job.JobClosed = 0;
        },
        openReworkModal() {
            this.reworkJobNum = null;
            this.dialogs.reworkDialog = true;
        },
        closeReworkModal() {
            this.dialogs.reworkDialog = false;
        },
    },
};
</script>

<style scoped>
.button-font {
    font-size: 12px;
}
.error-message {
    color: red;
    font-size: 13px;
}
</style>
